import { ReactNode } from 'react';

import Link from '@/components/core/Link';

interface IMobileMenuItemWrapperProps {
  isNotUrl: boolean;
  className: string;
  href: string;
  path?: string;
  onClick: () => void;
  children: ReactNode;
}
function MobileMenuItemWrapper({
  isNotUrl,
  className,
  href,
  path,
  onClick,
  children,
}: IMobileMenuItemWrapperProps) {
  if (isNotUrl) {
    return <div className={className}>{children}</div>;
  }
  return href.includes('https') ? (
    <a href={path} target="_blank" rel="noopener noreferrer" className={className}>
      {children}
    </a>
  ) : (
    <Link className={className} href={href} onClick={onClick}>
      {children}
    </Link>
  );
}

export default MobileMenuItemWrapper;
